module.exports = __webpack_public_path__ + "static/media/cubacel-logo.210ddc13.png";